import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { Box, FormHelperText } from "@mui/material";
import { MuiOtpInput } from "mui-one-time-password-input";
import { IconBrandWhatsapp, IconChevronRight, IconDeviceMobile } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import useCallApiAndLoad from "../../../../../../hooks/useCallApiAndLoad";
import { AppStore } from "../../../../../../redux/store";
import { useStep } from "usehooks-ts";
import Button from "../../../../../../components/form/Button";
import { useCustomerProfile } from "../../../../../Account/EditProfile/hooks/useProfile";

interface validateForm {
  code: string;
}
export interface CreateGuestVisit {
  project_id: string;
  date: string;
  start_time: number;
  visit_type: string;
  guest_id: string;
  code: string;
  admin_params?:any;
}

const PhoneStepTwo = ({helpers}: any) => {
  const { isLoading, callEndpoint } = useCallApiAndLoad();
  const { country } = useSelector((state: AppStore) => state.country);
  const {sendValidateOtp, resendCustomerOtp, errorMessage,
    errorMessageText,
    successMessageText, 
    successMessage,} = useCustomerProfile()
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<validateForm>({
    resolver: yupResolver(
      yup
        .object({
          code: yup.string().required("El código de verificación es requerido"),
        })
        .required()
    ),
  });

  const { goToNextStep, goToPrevStep } = helpers;

  const sendData = async (props: validateForm) => {

}

  const sendOtp = async (provider: string) => {
    // const { status, data } = await callEndpoint(sendGuestOTP({ guest_id: visitGuestData?.guest_id, provider: provider }));
    // if (status === 201) {
    //   setErrorMessage(true);
    //   setErrorMessageText("Codigo fue enviado");
    //   setTimeLeft(20);
    //   setIsTimerRunning(true); 
    //   window.scrollTo({
    //     top: 0,
    //     behavior: "smooth",
    //   });
    // }
  };



  const validateOtp = async (props: validateForm) => {
    await sendValidateOtp(props)
  }

  const [timeLeft, setTimeLeft] = useState(20); 
  const [isTimerRunning, setIsTimerRunning] = useState(true);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isTimerRunning) {
      interval = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(interval); 
            setIsTimerRunning(false);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval); 
  }, [isTimerRunning]);


  return (
    <div className="visit-form">
      {successMessage && (
        <div
          className="bg-[#E7F8EF] rounded-xl font-medium py-2 px-6 text-[#0E7C3A] mb-3"
          role="alert"
        >
          <p className=" text-sm">{successMessageText}</p>
        </div>
      )}
      {errorMessage && (
        <div
          className="bg-[#FEE2E2] rounded-xl font-medium py-2 px-6 text-[#B91C1C] mb-3"
          role="alert"
        >
          <p className=" text-sm">{errorMessageText}</p>
        </div>
      )}
      <form
        className="mt-6 max-w-xl mx-auto"
        onSubmit={handleSubmit(validateOtp)}
      >
        {errorMessage && (
          <div className="text-[#723b13] text-sm font-medium bg-[#fdfdea] rounded-xl w-full px-4 py-1 text-center my-1">
            <p>
              <span className="font-bold">Advertencia!</span> {errorMessageText}
            </p>
          </div>
        )}

        <h2 className="font-semibold text-lg">Te enviamos un código.</h2>
        <p className="text-base font-normal text-[#757575]">
        Ingresa el codigo que recibiste en tu número de télefono que ingresaste
      </p>{" "}

        <div className="w-full flex justify-center my-5 flex-col">
          <Controller
            name="code"
            control={control}
            rules={{ validate: (value) => value.length === 6 }}
            render={({ field, fieldState }) => (
              <Box>
                <MuiOtpInput
                  sx={{ gap: 1 }}
                  {...field}
                  length={6}
                  inputMode="numeric"
                  TextFieldsProps={{ type: "number" }}
                />
              
              </Box>
            )}
          />

          <p className=" text-sm font-semibold text-red text-left mt-2">
            {errors?.code?.message}
          </p>
        </div>
       
    <div className="w-full grid grid-cols-1 gap-4 mt-6 ">
            <Button
          type="submit"
          className="focus:outline-none py-3 rounded-lg bg-[#212121] text-white font-medium max-w-md mx-auto w-full"
        >
          <span className="mr-2">Finalizar proceso</span>
        </Button>
        </div>
    <hr className="mt-6 mb-6" />
    <p className="text-base text-[#212121] text-center">
          ¿No recibiste ningún código? Reintentar por{" "}
        
        </p>
        <div className="w-full grid grid-cols-1 gap-4 mt-4">
           <button
            onClick={() => resendCustomerOtp('whatsapp')}
              className={`w-full lg:w-64 mx-auto px-4 text-sm font-normal flex justify-center items-center gap-1 text-[#757575] bg-gray-200 py-2 rounded-xl ${
                isTimerRunning ? "opacity-50 cursor-not-allowed" : "hover:bg-primary hover:text-white"
              }`}
              disabled={isTimerRunning}
            >
              <IconBrandWhatsapp />
              Whatsapp
            </button>
          

      <button
        onClick={() => resendCustomerOtp('sms')}
        className={`w-full lg:w-64 mx-auto px-4 text-sm font-normal flex justify-center items-center gap-1 text-[#757575] bg-gray-200 py-2 rounded-xl ${
          isTimerRunning ? "opacity-50 cursor-not-allowed" : "hover:bg-primary hover:text-white"
        }`}
        disabled={isTimerRunning}
      >
        <IconDeviceMobile />
        Mensaje de texto
      </button>
      {isTimerRunning && (
        <p className="text-center text-sm text-gray-500">
          Las opciones se habilitarán en {timeLeft} segundos.
        </p>
      )}
    </div>
        {/* <p className="text-base text-[#212121] text-center">
          ¿Quieres cambiar el número de teléfono?{" "}
          <span
            className="text-base text-primary text-center cursor-pointer font-semibold"
            onClick={() => goToPrevStep()}
          >
            Cambiar
          </span>
        </p> */}
        
        
      </form>
    </div>
  );
};

export default PhoneStepTwo;
